import { render, staticRenderFns } from "./PersonalizationMicrosoftSummary.vue?vue&type=template&id=81602bf0&scoped=true"
import script from "./PersonalizationMicrosoftSummary.vue?vue&type=script&lang=js"
export * from "./PersonalizationMicrosoftSummary.vue?vue&type=script&lang=js"
import style0 from "./PersonalizationMicrosoftSummary.vue?vue&type=style&index=0&id=81602bf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81602bf0",
  null
  
)

export default component.exports